import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    flex: {
      display: "flex",
      marginTop: "16px",
      marginBottom: " 32px",
      background: theme.palette.common.white
    },
    normalFlex: {
      display: "flex"
    },
    actionButton: {
      width: "132px",
      fontSize: "14px",
      height: "40px"
    },
    brdRight: {
      borderRight: "1px solid #009FB8"
    },
    horzCenter: {
      margin: "0px"
    },
    rowFlex: {
      display: "flex",
      alignItems: "center"
    },
    flexRight: {
      marginLeft: "auto"
    },
    btnThin: {
      height: 32
    },
    boxBackground: {
      borderRadius: 4,
      background: theme.palette.background.default
    },
    boxBackgroundChangeOrder: {
      borderRadius: 4,
      background: theme.palette.background.default,
      padding: "9px 16px",
      height: 40
    },
    readOnlylabel: {
      margin: "0 0.8rem"
    },
    readOnlyField: {
      margin: "0.8rem",
      width: "96%"
    },
    boxSoldTo: {
      padding: 12,
      margin: "10px 0 24px 0"
    },
    colorInfo: {
      color: theme.palette.info.dark
    },
    boxCustomer: {
      padding: "16px 12px",
      margin: "10px 0 20px 0",
      "& .MuiTypography-root": {
        margin: "10px 0"
      },
      "& .MuiFormControl-root": {
        height: "4rem"
      }
    },
    boxGrid: {
      "& .MuiTypography-root": {
        margin: "10px 0"
      },
      "& .MuiFormControl-root": {
        height: "4rem"
      }
    },
    inlineBlock: {
      display: "inline-block",
      color: theme.palette.grey[900]
    },
    iconModal: {
      position: "absolute",
      left: "45%",
      top: "20px"
    },
    salesFieldWrap: {
      "& .MuiGrid-item": {
        marginBottom: "10px"
      },
      "& .fullWidth": {
        width: "100%"
      }
    },
    margBot10: {
      marginBottom: "10px"
    },
    margBot20: {
      marginBottom: "15px"
    },
    margRight20: {
      marginRight: "20px"
    },
    textError: {
      color: theme.palette.error.light,
      marginTop: 5
    },
    normalText: {
      fontWeight: "normal"
    },
    rowTitle: {
      marginBottom: 10
    },
    rowContent: {
      marginBottom: 20
    },
    marginBottom: {
      marginBottom: 2
    },
    marginTop: {
      marginTop: 2
    },
    required: {
      color: theme.palette.error.main
    },
    applyBtn: {
      width: "100%",
      height: "42px",
      padding: "0.6rem",
      fontSize: "14px",
      color: "white",
      backgroundColor: "#222",
      "& .MuiButton-label": {
        fontWeight: "700"
      }
    },
    oneTimeBtn: {
      width: "100%",
      height: "42px",
      padding: "0.6rem",
      fontSize: "14px",
      color: "white",
      backgroundColor: "#009FB8",
      "& .MuiButton-label": {
        fontWeight: "700"
      }
    },
    paymentTermAlignment: {
      width: "100%",
      height: "50%",
      display: "flex",
      alignItems: "center",
      overflow: "auto",
      margin: "auto !important",
      padding: "1rem 0"
    },
    shipToLabel: {
      whiteSpace: "pre-line",
      width: "75%"
    },
    selectField: {
      height: 40
    },
    salesEmployee: {
      width: "100%"
    },
    fullWidth: {
      width: "100%"
    },
    gridRow: {
      marginBottom: 15
    },
    pageHeader: {
      marginBottom: "1.2rem",
      "& > :first-child": {
        // visibility: props => (props.fullScreen ? "hidden" : "visible"),
        margin: 0
        // marginBottom: props => (props.fullScreen ? "0.4rem" : "1.2rem")
      },
      "& > :nth-child(2)": {
        alignSelf: "flex-end"
      }
    }
  }),
  { name: "NotRefSalesPartnerForm" }
);

export default useStyles;
